var widgetOptions = {
  apiKey: "1cfcf059-8e91-479e-91bb-dda7a23382ae",
  snippetId: "9AK1u5nGJqIfnngnt1Ma",
};

(function (n) {
  var u = function () {
      GlassixWidgetClient && typeof GlassixWidgetClient == "function"
        ? ((window.widgetClient = new GlassixWidgetClient(n)),
          widgetClient.attach(),
          window.glassixWidgetScriptLoaded &&
            window.glassixWidgetScriptLoaded())
        : f();
    },
    f = function () {
      r.onload = u;
      r.src = "https://cdn.glassix.net/clients/widget.1.2.min.js";
      i.parentNode.removeChild(t);
      i.parentNode.insertBefore(r, i);
    },
    i = document.getElementsByTagName("script")[0],
    t = document.createElement("script"),
    r;
  ((t.async = !0),
  (t.type = "text/javascript"),
  (t.crossorigin = "anonymous"),
  (t.id = "glassix-widget-script"),
  (r = t.cloneNode()),
  (t.onload = u),
  (t.src = "https://cdn.glassix.com/clients/widget.1.2.min.js"),
  !document.getElementById(t.id) && document.body) &&
    (i.parentNode.insertBefore(t, i), (t.onerror = f));
})(widgetOptions);
